/**
 * Adjust xhr options - sign URLs.
 *
 * This throws a warning in the Chrome console:
 *
 * [Deprecation] Synchronous XMLHttpRequest on the main thread is deprecated because of its
 * detrimental effects to the end user's experience. For more help, check https://xhr.spec.whatwg.org/.
 *
 * @TODO Look for an alternative way to sign URLs, video.js should be doing this, but currently can't.
 *
 * @param {Object} options
 * @return {Object}
 */
var beforeRequest = function(options) {
    var pathname;
    var el = document.createElement('a');

    el.href = options.uri;
    pathname = el.pathname.replace(/^\//, '');

    $.ajax({
        'type': 'GET',
        'url': '/cloud-asset-url?path=' + pathname,
        'dataType': 'json',
        'async': false

    }).done(function(response) {
        options.uri = response;
        return options;

    }).fail(function(response) {
        return options;
    });
};

module.exports = beforeRequest;
